<template>
  <div>
    <div class="remind container client_container">
      <div class="remind_text">
        <img class="remind_icon" src="@/assets/images/clients/icon_info_line.svg" alt="">
        本頁僅提供試聽，下載一刻鯨選享受完整聆聽服務
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'RemindText',
  data () {
    return {
      shareUrl: ''
    }
  },
  created () {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/clients.scss";

.remind {
  background-color:#E5F0F4;
  .remind_icon {
    width: 17px;
    margin-right: 2%;
  }
  .remind_text {
    font-size: 13px;
    line-height: 20px;
    color: rgba(0,0,0,0.6);
    padding: 9px 0;
    display: flex;
    align-items: center;
  }
  @media screen and (max-width: 320px){
    .remind_text {
      font-size: 12px;
    }
  }
}

@media screen and (min-width: 768px){
  .remind {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/clients/components/RemindText.vue